import { useFetch } from '@/shared/hooks/useFetch';
import { queryKeys } from '@/shared/api/queryKeys';
import { apiParcelsMyDebtsGet } from '@/entities/parcels/modules/api/parcels';

export const useMyParcelDebts = () =>
  useFetch({
    api: apiParcelsMyDebtsGet,
    keywords: queryKeys.parcels.myDebts,
    staleTime: 60_000,
  });
